import React, { useState } from 'react';
import { Autocomplete, MenuItem, TextField, Popover, Button, IconButton, InputAdornment } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export const quarterHours = Array.from({ length: 96 }, (_, i) =>
 `${Math.floor(i / 4).toString().padStart(2, '0')}:${((i % 4) * 15).toString().padStart(2, '0')}`);

export const formatTemplateDate = (value: string) => {
 if (!value) return '';
 const [year, month, day] = value.split('-').map(Number);
 return new Date(year, month - 1, day, 12).toLocaleDateString('es-ES', {
  weekday: 'long', day: 'numeric', month: 'long',
 });
};

export default function ClinicTemplateInput({ role, value, disabled, pets, onChange }: {
 role: string; value: string; disabled: boolean; pets: { id: string; name: string }[];
 onChange: (value: string) => void;
}) {
 const [date, setDate] = useState('');
 const [anchor, setAnchor] = useState<HTMLElement | null>(null);
 const [month, setMonth] = useState(() => new Date(new Date().getFullYear(), new Date().getMonth(), 1));
 const [hour, setHour] = useState(value.split(':')[0] || '');
 const [minute, setMinute] = useState(value.split(':')[1] || '');
 if (role === 'pet') return <Autocomplete
  freeSolo options={Array.from(new Set(pets.map(p => p.name)))}
  inputValue={value} value={value || null} disabled={disabled}
  onInputChange={(_, text) => onChange(text)}
  renderInput={params => <TextField {...params} label="Mascota" size="small" placeholder="Selecciona o escribe" />}
 />;
 if (role === 'date') return <>
  <TextField label="Fecha" size="small" fullWidth disabled={disabled} value={date ? date.split('-').reverse().join('/') : ''} placeholder="dd/mm/aaaa"
   onClick={event => { if (!disabled) setAnchor(event.currentTarget); }}
   InputProps={{readOnly:true,endAdornment:<InputAdornment position="end"><IconButton disabled={disabled} aria-label="Abrir calendario"><CalendarMonthIcon /></IconButton></InputAdornment>}} />
  <Popover open={!!anchor} anchorEl={anchor} onClose={() => setAnchor(null)} anchorOrigin={{vertical:'bottom',horizontal:'left'}}>
   <div role="dialog" aria-label="Seleccionar fecha" lang="es" style={{padding:16,width:300}}>
    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
     <IconButton aria-label="Mes anterior" onClick={() => setMonth(new Date(month.getFullYear(),month.getMonth()-1,1))}>‹</IconButton>
     <strong>{month.toLocaleDateString('es-ES',{month:'long',year:'numeric'})}</strong>
     <IconButton aria-label="Mes siguiente" onClick={() => setMonth(new Date(month.getFullYear(),month.getMonth()+1,1))}>›</IconButton>
    </div>
    <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',textAlign:'center'}}>
     {['L','M','X','J','V','S','D'].map(day => <span key={day}>{day}</span>)}
     {Array.from({length:(month.getDay()+6)%7},(_,i) => <span key={`empty${i}`} />)}
     {Array.from({length:new Date(month.getFullYear(),month.getMonth()+1,0).getDate()},(_,i) => {
      const iso=`${month.getFullYear()}-${String(month.getMonth()+1).padStart(2,'0')}-${String(i+1).padStart(2,'0')}`;
      return <Button key={iso} aria-label={formatTemplateDate(iso)} variant={date===iso?'contained':'text'} style={{minWidth:0}}
       onClick={() => {setDate(iso);onChange(formatTemplateDate(iso));setAnchor(null);}}>{i+1}</Button>;
     })}
    </div>
    <Button onClick={() => {setDate('');onChange('');setAnchor(null);}}>Borrar</Button>
    <Button onClick={() => setAnchor(null)}>Cerrar</Button>
   </div>
  </Popover>
 </>;
 return <div style={{display:'flex',gap:8}}>
  <TextField label="Hora" select size="small" fullWidth disabled={disabled} value={hour}
   onChange={event => {setHour(event.target.value);onChange(minute ? `${event.target.value}:${minute}` : '');}}>
   {Array.from({length:24},(_,i) => String(i).padStart(2,'0')).map(h => <MenuItem key={h} value={h}>{h}</MenuItem>)}
  </TextField>
  <TextField label="Minutos" select size="small" fullWidth disabled={disabled} value={minute}
   onChange={event => {setMinute(event.target.value);onChange(hour ? `${hour}:${event.target.value}` : '');}}>
   {['00','15','30','45'].map(m => <MenuItem key={m} value={m}>{m}</MenuItem>)}
  </TextField>
 </div>;
}
